var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-wrapper',{attrs:{"instance":_vm.instance}},[_c('div',{class:[(_vm.$appPrefix + "-not-implemented-module")]},[_c('h2',[_vm._v("Not implemented: "+_vm._s(_vm.type))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.instance))])])])}
var staticRenderFns = []

export { render, staticRenderFns }